import React from 'react'
import { useState, useEffect } from 'react';
import Carousel from 'react-bootstrap/Carousel';

function Carousal() {
  const [carousalist, setCarousallist] = useState([]);

  useEffect(() => {
    // Fetch Function   
    fetch("assets/data/carousels/carousel_list.json").then(
      function (res) {

        return res.json()
      }).then(data => {
        //alert(data[1].url)
        setCarousallist(data);
      })
      //setThoughts(filtered)
      //setMsg(filtered.Msg)
      //alert({msg})
      .catch(error => console.error('Error fetching carousels:', error));
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <Carousel
        controls={false}
        indicators={false}
      >
        {carousalist.map((carousal, index) => (
          <Carousel.Item key={index} interval={5000}>
            <div
              style={{
                height: "80vh",        // LOCK HEIGHT
                width: "100%",
                overflow: "hidden"
              }}
            >
              <img
                src={carousal.url}
                alt={carousal.name}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover"   // VERY IMPORTANT
                }}
              />
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}

export default Carousal